import { chatIcon, closeIcon } from './icons';
import { t } from '../i18n';
import { useWidgetStore, useShadow } from '../state/createWidgetStore';
import type { ButtonHTMLAttributes } from 'react';

export function FloatingButton() {
  const isOpen = useWidgetStore((s) => s.isOpen);
  const toggleOpen = useWidgetStore((s) => s.toggleOpen);
  const shadow = useShadow();
  const partProps = { part: 'fab' } as unknown as ButtonHTMLAttributes<HTMLButtonElement>;

  const handleClick = () => {
    toggleOpen();
    // Read state after toggle - use the inverse of current value
    const willBeOpen = !isOpen;
    (shadow.host as HTMLElement).dispatchEvent(
      new CustomEvent(willBeOpen ? 'mcp-chat:open' : 'mcp-chat:close', {
        bubbles: true,
        composed: true,
      })
    );
  };

  return (
    <button
      {...partProps}
      className="fab"
      aria-label={isOpen ? t('close') : t('title')}
      onClick={handleClick}
      dangerouslySetInnerHTML={{ __html: isOpen ? closeIcon : chatIcon }}
    />
  );
}
